<template>
  <modal
    name="introduction-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto"
  >
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closeDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>
    <div
      style="display: inline-block; min-width: 100%; text-align: center"
      v-if="$firebase.isAuthenticated"
    >
      <p style="font-size: 120%">推薦・紹介文の作成をお願いしよう！</p>
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 100%; text-align: left">
          あなたの名前：<br />{{ username }}
        </p>
        <p style="font-size: 100%; text-align: left">
          あなたのメールアドレス：<br />{{ email }}
        </p>
      </div>
      <br />
      <div style="padding: 20px 0; font-size: 70%; color: red">
        ※推薦・紹介文が作成されたら、上記のメールアドレスにお知らせいたします。
      </div>
      <br />
      <p style="font-size: 120%">お願いする相手の情報：</p>
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 100%; text-align: left">
          姓名：<br />
          <el-input
            class="input-md"
            placeholder=""
            title="姓名"
            ref="introName"
            v-model="introName"
            type="email"
          ></el-input>
        </p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 100%; text-align: left">
          メールアドレス：<br />
          <el-input
            class="input-md"
            placeholder=""
            title="メールアドレス"
            ref="introEmail"
            v-model="introEmail"
            type="email"
          ></el-input>
        </p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 100%; text-align: left">
          関係：<br />
          <el-select
            v-model="relationship"
            @change="relationshipChange"
            placeholder="選択してください"
          >
            <el-option
              v-for="item in relationshipOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option> </el-select
          ><br />
          <el-input
            class="input-md"
            v-if="isRelationshipEtc"
            placeholder=""
            title=""
            ref="relationshipEtc"
            v-model="relationshipEtc"
            type="email"
          ></el-input>
        </p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 100%; text-align: left">
          <span style="">作成期限は依頼してから２週間後になります。</span>
          <el-date-picker
            v-if="false"
            v-model="limitDate"
            type="date"
            :clearable="false"
            placeholder="選択してください"
            :format="'yyyy年M月d日'"
            ref="limit_date"
          >
          </el-date-picker>
        </p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <br />
        <p style="font-size: 100%; text-align: left">
          お願い内容：<el-button
            @click="$modal.show('requestsample-dialog')"
            type="success"
            >例文から追加</el-button
          ><br />
          <br />
          <modal
            name="requestsample-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto"
          >
            <div class="v--modal-close-top">
              <el-button
                @click="$modal.hide('requestsample-dialog')"
                icon="el-icon-close"
                type="text"
              ></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">
                例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。
              </p>
            </div>
            <ul class="example-sentence">
              <li
                v-for="(item, idx) in exampleSentences.request_statement"
                v-on:click="
                  requestStatement +=
                    item.description.replace(/<br>/gi, '\n') + '\n'
                  $modal.hide('requestsample-dialog')
                "
                :key="idx"
              >
                <div class="title">{{ item.title }}</div>
                <div class="body" v-html="item.description"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('requestsample-dialog')"
                >閉じる</el-button
              >
            </div>
          </modal>
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 15 }"
            v-model="requestStatement"
          ></el-input>
        </p>
      </div>
      <div
        style="display: inline-block; min-width: 100%; text-align: center"
        v-if="false"
      >
        <p style="font-size: 100%; text-align: left">
          <span style="color: red"
            >※推薦・紹介文の作成依頼は３人までとなります。</span
          >
        </p>
      </div>
      <div class="text-center">
        <br />
        <el-button
          id="send-introduction"
          type="success"
          v-if="isSended == false"
          style="background-color: #e3165c; border-color: #e3165c; color: #fff"
          @click="$eventHub.$emit('request-introductiondata')"
          >お願いを送信する</el-button
        >
        <el-button
          id="send-adtop-pdf"
          type="success"
          v-if="isSended == true"
          style="background-color: #0f9934; border-color: #0f9934"
          @click="closeDialog()"
          >送信しました</el-button
        >
      </div>
      <br />
    </div>
    <div
      style="display: inline-block; min-width: 100%; text-align: center"
      v-else
    >
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          <img
            src="/static/renew_img/bnr/recomm_20221005_001.png"
            style="width: 100%"
          />
        </p>
      </div>
      <div style="padding: 20px 0; font-size: 70%">
        Yagishの<router-link
          id="footer-link-terms"
          :to="{ name: 'termsPage' }"
          target="_blank"
          >利用規約</router-link
        >、<router-link
          id="footer-link-terms"
          :to="{ name: 'policyPage' }"
          target="_blank"
          >個人情報の取り扱い</router-link
        >について<br />
        に同意の上、ログインしてください。
      </div>
      <div class="text-center">
        <login-forms />
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import LoginForms from '@/components/LoginSpecialForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      isAgree: false,
      email: '',
      introEmail: '',
      introName: '',
      dispSaveform: true,
      dispLoadform: false,
      confirmCode: '',
      relationship: '',
      requestStatement: '',
      relationshipEtc: '',
      limitDate: '',
      isRelationshipEtc: false,
      relationshipOptions: [
        {
          value: '両親・親族',
          label: '両親・親族'
        },
        {
          value: '担当教授',
          label: '担当教授'
        },
        {
          value: '知人',
          label: '知人'
        },
        {
          value: '上司（アルバイト先など）',
          label: '上司（アルバイト先など）'
        },
        {
          value: '同僚',
          label: '同僚'
        },
        {
          value: 'その他',
          label: 'その他'
        }
      ],
      exampleSentences: {
        // 志望動機
        request_statement: [
          {
            title: '',
            description:
              'お世話になります。\n〇〇大学〇〇学部〇〇学科の▲▲▲▲です。\nこの度は、私の就職に関しましてお願いがあり、メールさせていただきました。\n私は現在、〇〇〇〇を活かすことができる企業への就職を希望し、〇〇業界を中心に就職活動をしております。\nそこで、長年ご一緒させていただいた〇〇様に私の推薦文を書いていただきたいと思っております。\nご多忙の中、誠に申し訳ありませんが、お力添えの程、何卒よろしくお願いいたします'
          }
        ]
      }
    }
  },
  created: function () {
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    relationshipChange: function () {
      if (this.relationship == 'その他') {
        this.isRelationshipEtc = true
      } else {
        this.isRelationshipEtc = false
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message({
            message: '復旧コードをコピーしました。',
            type: 'info'
          })
        })
        .catch((e) => {
          console.error(e)
        })
    },
    openDialog: function (id, html) {
      const app = this
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$iterateStorage(
        function (value, key, iterationNumber) {
          if (key === 'basicData') {
            app.username = value.lastName + ' ' + value.firstName
            app.email = value.email
          }
        },
        function (err) {
          if (!err) {
            console.log('Iteration has completed')
          }
        }
      )
      this.$modal.show('introduction-dialog')
    },
    closeDialog: function () {
      this.$modal.hide('introduction-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    saveIntroductiondata: async function () {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (app.email == '') {
        this.$message({
          message: 'メールアドレスを入力してください',
          type: 'error'
        })
        return
      }
      console.error(this.$formLib.dateFormat(app.limitDate, 'yyyy/mm/dd'))

      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.introName) {
        this.$message({
          message: 'お願いする相手の姓名を入力してください',
          type: 'warning'
        })
        return
      }
      if (!this.introEmail) {
        this.$message({
          message: 'お願いする相手のメールアドレスを入力してください',
          type: 'warning'
        })
        return
      }
      if (!this.requestStatement) {
        this.$message({
          message: 'お願い内容を入力してください',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('intro_name', this.introName)
      formData.append('request_name', this.username)
      formData.append('request_email', this.email)
      formData.append('format_id', this.formatid)
      formData.append('intro_email', this.introEmail)
      formData.append('relationship', this.relationship)
      formData.append(
        'limit_date',
        this.$formLib.dateFormat(app.limitDate, 'yyyy/mm/dd')
      )
      formData.append('request_statement', this.requestStatement)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('relationship_etc', this.relationshipEtc)

      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.requestIntroduction, formData, {
          timeout: 60000
        })
        .then(function (response) {
          // app.isSended = true
          app.closeDialog()
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: 'お願いを送信しました',
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '応募に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('request-introductiondata', this.saveIntroductiondata)
    this.$eventHub.$on('open-introduction-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('request-introductiondata', this.saveIntroductiondata)
    this.$eventHub.$off('open-introduction-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
